export const NETWORK_ERROR_CODE = {
  AI_DESCRIBING_ERROR: 'AI_DESCRIBING_ERROR',
  INVALID_CURRENT_PASSWORD: 'INVALID_CURRENT_PASSWORD',
  PLAN_NOT_GENERATED: 'PLAN_NOT_GENERATED',
  TOO_MANY_ATTEMPTS: 'TOO_MANY_ATTEMPTS',
  USER_IS_OVER_CHAT_LIMIT: 'USER_IS_OVER_CHAT_LIMIT',
  USER_NOT_FOUND: 'USER_NOT_FOUND',
  USER_SHOULD_ACCEPT_CHAT_POLICY: 'USER_SHOULD_ACCEPT_CHAT_POLICY',
  TOKEN_IS_INVALID: 'TOKEN_IS_INVALID',
};

// INFO: For errors where the "error_code" key cannot be added on the backend
export const NETWORK_ERROR = {
  isEmailHasBeenTaken: 'The email has already been taken.',
  isUserExist: 'User already exists',
};
